import React from "react"
import MessageBuilderActions from "./actions/MessageBuilderActions"
import MessageBuilderStore from "./stores/MessageBuilderStore"
import ModalButtons from "../ModalButtons/ModalButtons"
import Tabs from "../Tabs/Tabs";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import ErrorHelper from "../Errors/ErrorHelper";
import MessageBuilderWorkspace from "./MessageBuilderWorkspace";

export default class MessageBuilder extends React.Component{
  constructor(props) {
    super(props);
    this.state = this.getStateFromStores()
    this.onChangeImages = this.onChangeImages.bind(this)
    this._onChange = this._onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.setActiveTab = this.setActiveTab.bind(this);
  }

  componentDidMount() {
    MessageBuilderStore.addChangeListener(this._onChange);
    MessageBuilderActions.init(this.props);

    $('#new_message').prepend('<input autocomplete="false" name="hidden" type="text" style="display:none;">');
  }

  getStateFromStores() {
    return {
      message: MessageBuilderStore.getMessage(),
      focusedInput: MessageBuilderStore.getFocusedInput(),
      formFieldId: MessageBuilderStore.getFormFieldId(),
      textVariables: MessageBuilderStore.getTextVariables(),
      sendTestMessagePath: MessageBuilderStore.getSendTestMessagePath(),
      errors: MessageBuilderStore.getErrors(),
      active_tab: MessageBuilderStore.getActiveTab(),
      room_types: MessageBuilderStore.getRoomTypes(),
    }
  }

  render() {
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: this.onSubmit,
      },
    ]

    return (
      <div className="message-builder" ref="message_builder">
        <ModalButtons buttons={buttons} />
        <Tabs tabs={this.tabs()}/>

        <div className="panel panel-form">
          <MessageBuilderWorkspace {...this.props} {...this.state} onChangeImages={this.onChangeImages}/>
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  tabs() {
    var tabs = [];

    tabs.push({
      tabName: I18n.t("general"),
      targetName: "general",
      classes: this.state.active_tab === "general" ? "active" : null,
      changeHandler: this.setActiveTab,
      tabErrorCount: ErrorHelper.tabErrorCount(this.state.errors, ['code', 'name', 'body', 'time_period', 'to']),
    });
    {
      this.state.message && !this.state.message.lifecycle_event.includes('order')
      ?
      tabs.push({
        tabName: I18n.t("sources"),
        targetName: "sources",
        classes: this.state.active_tab === "sources" ? "active" : null,
        changeHandler: this.setActiveTab,
        tabErrorCount: ErrorHelper.tabErrorCount(this.state.errors, ['sources']),
      })
      :
      null
    }

    {
      this.state.message && this.props.reservation_segment_email_events.includes(this.state.message.lifecycle_event)
      ?
      tabs.push({
        tabName: I18n.t("room_types"),
        targetName: "room_types",
        classes: this.state.active_tab === "room_types" ? "active" : null,
        changeHandler: this.setActiveTab,
        tabErrorCount: ErrorHelper.tabErrorCount(this.state.errors, ['room_types']),
      })
      :
      null
    }

    return tabs;
  }

  _onChange() {
    this.setState(this.getStateFromStores());
  }

  onChangeImages(image_group) {
    var image_group_ids = image_group.images.map((image) => image.id);
    if (image_group) {
      this.setState({
        image_group_ids: image_group_ids,
        image_group: image_group,
      });
    } else {
      this.setState({
        image_group_ids: null,
        image_group: null,
      });
    }

    MessageBuilderActions.setImages(image_group.images);
  }

  onSubmit() {
    var self = this
    var params = this.state
    self.setState({ loading: true })
    setTimeout(function () {
      $.ajax({
        type: self.props.is_new ? 'POST' : 'PATCH',
        url: self.props.is_new
          ? self.props.paths.message_create_path
          : self.props.paths.message_save_path,
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(params),
      }).done(function (data) {
        if (Object.keys(data.errors).length) {
          MessageBuilderActions.setErrors(data.errors);
          self.setState({ loading: false })
        }
        else {
          self.setState({ loading: false })
          window.parent.$(window.parent).trigger("textingTemplateSavedSuccessfully")
          if (parent && parent.refresh_data) {
            if (self.props.is_new == true) {
              parent.refresh_data(I18n.t('texting_template_created_successfully'));
            } else {
              parent.refresh_data(I18n.t('texting_template_saved_successfully'));
            }
          }
          if (parent && parent.hide_modal) {
            parent.hide_modal()
          }
        }
      })
    }, 1000)
  }

  setActiveTab(tab) {
    MessageBuilderActions.setActiveTab(tab);
  }
};